import { useQuery } from '@tanstack/react-query';

import { UseQuery } from 'services/api/types';

import { api_getMyself } from './users.queries';
import { Myself } from './users.types';

export const useMyself: UseQuery<Myself> = options =>
  useQuery(['users', 'myself'], () => api_getMyself(), options as any);
